import { useCallback, useState } from 'react';

type UseExpandCollapseReturn = {
  isExpanded: (id: string) => boolean;
  toggleExpand: (id: string) => void;
};

const useExpandCollapse = (): UseExpandCollapseReturn => {
  const [collapsedIds, setCollapsedIds] = useState<Set<string>>(new Set());

  const isExpanded = useCallback((id: string): boolean => !collapsedIds.has(id), [collapsedIds]);

  const toggleExpand = useCallback((id: string): void => {
    setCollapsedIds((prev) => {
      const next = new Set(prev);

      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }

      return next;
    });
  }, []);

  return { isExpanded, toggleExpand };
};

export default useExpandCollapse;
